
/**
 * previewResource 在线查看文件
 * setStarCloudResource 设置标签
 * resourceInfo 查看文件夹
 * downloadResource 下载文件
 * editFile 编辑文件
 * renameFile 重命名文件
 * saveResourceToCloud 保存到网盘
 * deleteResource 删除文件/文件夹
 * uploadFiles 创建/上传文件
 * createPublish 新建发布（包括发布文件/发布文件夹）
 * managePublish 管理发布（包括编辑和取消发布）
 * createFolder 创建文件夹
 * renameFolder 重命名文件夹
 * editResourcePermission 修改共享文件夹权限
 * viewHistoryVersion 查看历史版本
 */
 const rolePermissions = {
  // 拥有者
  1: [
    "previewResource",
    "setStarCloudResource",
    "resourceInfo",
    "downloadResource",
    "editFile",
    "renameFile",
    "saveResourceToCloud",
    "deleteResource",
    "editResourcePermission",
    "renameFolder",
    "createFolder",
    "uploadFiles",
    "createPublish",
    "managePublish",
    "viewHistoryVersion",
  ],
  // 上传下载
  2: [
    "previewResource",
    "setStarCloudResource",
    "resourceInfo",
    "downloadResource",
    "editFile",
    "renameFile",
    "saveResourceToCloud",
    "deleteResource",
    "renameFolder",
    "createFolder",
    "uploadFiles",
    "viewHistoryVersion",
  ],
  // 仅下载
  3: [
    "previewResource",
    "resourceInfo",
    "downloadResource",
    "saveResourceToCloud",
  ],
  // 仅上传
  4: [
    "previewResource",
    "resourceInfo",
    "editFile",
    "renameFile",
    "uploadFiles",
  ],
  // 仅预览
  5: [
    "previewResource",
    "resourceInfo",
  ],
  // 发布
  6: [
    "previewResource",
    "setStarCloudResource",
    "resourceInfo",
    "downloadResource",
    "editFile",
    "renameFile",
    "saveResourceToCloud",
    "deleteResource",
    "renameFolder",
    "createFolder",
    "uploadFiles",
    "createPublish",
    "managePublish",
    "viewHistoryVersion",
  ],
  // 管理者
  7: [
    "previewResource",
    "setStarCloudResource",
    "resourceInfo",
    "downloadResource",
    "editFile",
    "renameFile",
    "saveResourceToCloud",
    "deleteResource",
    "editResourcePermission",
    "renameFolder",
    "createFolder",
    "uploadFiles",
    "viewHistoryVersion",
  ],
};

// 返回权限角色名称
export function getRole(role_type){
  let role = '';
  switch (role_type) {
    case 1:
      role = '拥有者'
      break;
    case 2:
      role = '上传下载'
      break;
    case 3:
      role = '仅下载'
      break;
    case 4:
      role = '仅上传'
      break;
    case 5:
      role = '仅预览'
      break;
    case 6:
      role = '发布'
      break;
    case 7:
      role = '管理者'
      break;
    default:
      break;
  }
  return role;
}

export function getRoleDesc(role_type){
  let role = '';
  switch (role_type) {
    case 1:
      role = '对文件夹具有管理权限。可以查看、上传（创建）、编辑、下载、删除文件夹中的所有文件；设置文件夹的共享权限。'
      break;
    case 2:
      role = '可以查看、上传(创建)、编辑、删除这个文件夹中的所有文件，适合于群成员间的协同办公'
      break;
    case 3:
      role = '只能在线查看或下载这个文件夹中的文件，不能创建、删除、修改里面的文件，适合共享仅查看的资料，如：管理制度、实验记录等'
      break;
    case 4:
      role = '只能在文件夹上传文件，不能查看、下载、删除里面的TA人文件，适合于收集资料，但又不希望提交材料的人相互看见。如：收集周报、老师收学生作业等'
      break;
    case 5:
      role = '只能通过网页在线查看这个文件夹中的文件，不能下载、创建、删除、修改里面的文件。适合于分享一些涉密资料，不希望被访问者下载复制'
      break;
    case 6:
      role = '睿客网“发布”功能，是睿客网“群盘”提供的服务（默认群盘不开通该功能，使用该功能前需要向睿客网系统管理员申请开通）。发布功能，可以为用户的群盘文件生成访问链接，并能设置相关访问策略（如：IP限制、访问密码等），用于第三方系统引入使用。'
      break;
    case 7:
      role = '对文件夹具有管理权限。可以查看、上传（创建）、编辑、下载、删除文件夹中的所有文件；设置文件夹的共享权限。该权限可被取消'
      break;
    default:
      break;
  }
  return role;
}

// 返回所有权限列表
export function getRolePermissions(role_type){
  return rolePermissions[role_type];
}